<template>
  <div>
    <b-alert variant="warning" :show="cancellingFunds.length === 0">No tiene fondo de cancelación</b-alert>

    <b-table :items="cancellingFundsItems" :fields="cancellingFundFields" hover striped>
      <template #cell(limit)="data">
        {{ moneyString(data.item.limit) }}
      </template>
      <template #cell(actions)="data">
        <b-button variant="danger" size="sm" @click="deleteCancellingFund(data.index)" v-if="data.item.new">Eliminar</b-button>
      </template>
      <template #head(type)="data">
        <b-button variant="primary" size="sm" @click="add" v-if="!adding && state != 'showing'">Agregar</b-button>
      </template>
    </b-table>

    <div v-if="adding">
      <b-form>
        <b-form-row>
          <b-col>
            <b-form-group horizontal label="Tipo">
              <b-form-select v-model="newCF.type_id" :options="cancellingFundTypeOptions"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group horizontal label="Limite">
              <b-form-input v-model="newCF.limit" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <div class="text-right">
              <b-form-group>
                <b-button variant="success" @click="add">Agregar</b-button>
                <b-button variant="danger" @click="reset">Cancelar</b-button>
              </b-form-group>
            </div>
          </b-col>
        </b-form-row>
      </b-form>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { moneyString } from '../../utils';

export default {
  data() {
    return {
      cancellingFundFields: [
        {
          key: 'type',
          label: 'Tipo'
        },
        {
          key: 'limit',
          label: 'Limite'
        },
        {
          key: 'actions',
          label: ' '
        }
      ],
      adding: false,
      newCF: {
        type_id: null,
        type: '',
        limit: 0,
        new: true
      }
    }
  },
  computed: {
    tyoes() {
      // debugger
    },
    ...mapState({
      cancellingFundTypes: state => state.employeeManager.cancellingFundTypes,
      cancellingFunds: state => state.employeeManager.employee.cancellingFunds,
      currency: state => state.employeeManager.employee.currency,
      state: state => state.employeeManager.state,
    }),
    cancellingFundsItems() {
      return this.cancellingFunds.map(cf => {
        return {
          type: cf.type,
          limit: cf.limit,
          new: cf.new || false,
        }
      });
    },
    cancellingFundTypeOptions() {
      // debugger
      return [{ text: 'Elija una opción', value: null }].concat(this.cancellingFundTypes.map(cft => {
        return {
          'text': cft.name,
          'value': cft.id
        };
      }));
    }
  },
  methods: {
    moneyString: moneyString,
    ...mapMutations({
      pushCancellingFund: 'pushCancellingFund',
      deleteCancellingFund: 'deleteCancellingFund'
    }),
    add() {
      if (this.adding) {
        if (this.newCF.type_id) {
          let type = this.cancellingFundTypes.find(t => t.id == this.newCF.type_id);
          this.newCF.type = type.name;
          this.pushCancellingFund({...this.newCF, limit: { amount: this.newCF.limit * 100, currency: this.currency }});
          this.reset();
        }
      } else {
        this.adding = true;
      }
    },
    reset() {
      this.adding = false;
      this.resetNewCF();
    },
    resetNewCF() {
      this.newCF.type = null;
      this.newCF.limit = 0;
    }
  }
}
</script>
